import { render } from "./RegionTurkystan.vue?vue&type=template&id=3844d032&ts=true"
import script from "./RegionTurkystan.vue?vue&type=script&lang=ts"
export * from "./RegionTurkystan.vue?vue&type=script&lang=ts"

import "./RegionTurkystan.vue?vue&type=style&index=0&id=3844d032&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__